import { FiClock, FiDollarSign } from 'react-icons/fi';

const RecipeBasicInfo = ({ localRecipe, handleLocalInputChange, isSubmitting, currency }) => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Recipe Name*</label>
          <input
            type="text"
            name="name"
            value={localRecipe.name}
            onChange={handleLocalInputChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
            required
            disabled={isSubmitting}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Cost ({currency.symbol})*</label>
          <div className="relative">
            
            <input
              type="number"
              name="cost"
              value={localRecipe.cost}
              onChange={handleLocalInputChange}
              className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              required
              min="0"
              disabled={isSubmitting}
            />
          </div>
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
        <textarea
          name="description"
          value={localRecipe.description}
          onChange={handleLocalInputChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
          rows="2"
          disabled={isSubmitting}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Preparation Time (minutes)*</label>
          <div className="relative">
            <FiClock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="number"
              name="preparationTime"
              value={localRecipe.preparationTime}
              onChange={handleLocalInputChange}
              className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              required
              min="1"
              placeholder="30"
              disabled={isSubmitting}
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Expiry Duration (days)</label>
          <input
            type="number"
            name="expiryDuration"
            value={localRecipe.expiryDuration}
            onChange={handleLocalInputChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
            placeholder="e.g. 3"
            min="0"
            disabled={isSubmitting}
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Instructions*</label>
        <textarea
          name="instructions"
          value={localRecipe.instructions}
          onChange={handleLocalInputChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
          rows="4"
          placeholder="Step-by-step instructions..."
          required
          disabled={isSubmitting}
        />
      </div>
    </>
  );
};

export default RecipeBasicInfo;